import { ListLoader as BaseListLoader } from "./vendor/ListLoader/main.js";

export type ListLoaderProps = {
  className?: string | undefined;
};

export const ListLoader = (props: ListLoaderProps) => (
  <BaseListLoader {...props} />
);
